import { Stack } from "@mantine/core";
import Header from "./Header";
import "./support.scss";
import Footer from "./Footer";
import lazyRetry from "../../functions/lazyRetry";
import { useSupportLanguage } from "./stores/SupportLanguageStore";
const KnowledgeBase = lazyRetry(() => import("./base/KnowledgeBase"));

const Support = () => {
  const lang = useSupportLanguage((s) => s.language);

  document.title = ` ${lang.title}`;
  return (
    <Stack w={"100%"} gap={0}>
      <Header />
      <KnowledgeBase />
      <Footer />
    </Stack>
  );
};

export default Support;
